import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 3.5 19 2l-2.608 2.196A3 3 0 0 0 15.5 4h-9a3 3 0 0 0-2.583 1.852L3.37 7.177s1.493.108 2.129.323l.5-1S6.5 6 7 6h7.25l-5.931 4.995A10.95 10.95 0 0 0 2 9v2l.265.004a8.95 8.95 0 0 1 4.459 1.334l-1.637 1.378A7 7 0 0 0 2 13v2l.217.005q.586.025 1.128.178L0 18l1.5 1.5zm-8.88 11.162-1.565 1.318A8.96 8.96 0 0 1 11 20h2l-.004-.288a10.94 10.94 0 0 0-1.376-5.05m-3.153 2.655-1.638 1.38C6.94 19.112 7 19.549 7 20h2l-.004-.24a7 7 0 0 0-.529-2.443M20.714 7.004l-3.14 2.644L19 12.5v5L18 16h-3.627q.314.97.474 2H17l1.5 2H21v-7.5l-1.021-2.479L21 9h1V7h-1.197zM16.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      fill={color}
    />
  </svg>
);
